import { render } from "./StatisticDetail.vue?vue&type=template&id=82f4f776"
import script from "./StatisticDetail.vue?vue&type=script&lang=js"
export * from "./StatisticDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\forteapp-sales\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QScrollArea,QList,QDialog,QCard});
